"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTwitterPost = void 0;
var React = __importStar(require("react"));
var IconTwitterPost = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { id: "Twitter-post", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Post-Twitter" },
            React.createElement("rect", { id: "Background", fill: "#00ACEE", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("g", { id: "Social/ic_twitter", transform: "translate(5.000000, 5.000000)" },
                React.createElement("path", { d: "M8.2896,20 C15.8366,20 19.9646,13.844 19.9646,8.505 C19.9646,8.33 19.9646,8.156 19.9526,7.983 C20.7556,7.411 21.4496,6.703 21.9996,5.892 C21.2506,6.219 20.4566,6.433 19.6436,6.527 C20.4996,6.022 21.1416,5.229 21.4476,4.293 C20.6416,4.764 19.7606,5.095 18.8416,5.273 C17.2876,3.646 14.6886,3.568 13.0356,5.098 C11.9706,6.085 11.5186,7.555 11.8486,8.958 C8.5496,8.795 5.4756,7.261 3.3926,4.737 C2.3026,6.583 2.8596,8.944 4.6626,10.13 C4.0096,10.111 3.3706,9.937 2.7996,9.624 L2.7996,9.676 C2.8006,11.599 4.1776,13.255 6.0916,13.636 C5.4876,13.798 4.8536,13.821 4.2396,13.705 C4.7766,15.351 6.3176,16.479 8.0726,16.511 C6.6196,17.635 4.8246,18.245 2.9766,18.243 C2.6506,18.243 2.3246,18.224 1.9996,18.186 C3.8766,19.371 6.0606,20 8.2896,19.997", id: "ic_twitter", fill: "#F7F7F7", fillRule: "evenodd" }),
                React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 })))))); };
exports.IconTwitterPost = IconTwitterPost;
exports.IconTwitterPost.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconTwitterPost;
